module.exports = __webpack_public_path__ + "img/home-visual-01_m.36e86a54.png";